import { useEffect, useRef, useState } from 'react';
import { useReducedMotion } from 'framer-motion';

const INTERO = /^\d+$/;

/**
 * Un numero che conta da zero quando entra in vista.
 *
 * Solo i valori interi puri: «100+» e «1.400+» sono stime tonde e animarle
 * farebbe credere a un conteggio preciso che non c'e'. Lo screen reader legge
 * sempre il valore vero, mai le cifre intermedie.
 */
export const CountUp = ({ value, className = '' }) => {
  const ridotto = useReducedMotion();
  const testo = String(value ?? '');
  const anima = INTERO.test(testo) && !ridotto;
  const ref = useRef(null);
  const [n, setN] = useState(0);

  useEffect(() => {
    if (!anima || !ref.current) return undefined;
    const fine = Number(testo);
    let raf = 0;
    const io = new IntersectionObserver(
      ([e]) => {
        if (!e.isIntersecting) return;
        io.disconnect();
        const t0 = performance.now();
        const passo = (t) => {
          const k = Math.min(1, (t - t0) / 1200);
          setN(Math.round(fine * (1 - (1 - k) ** 3)));
          if (k < 1) raf = requestAnimationFrame(passo);
        };
        raf = requestAnimationFrame(passo);
      },
      { threshold: 0.6 },
    );
    io.observe(ref.current);
    return () => {
      io.disconnect();
      cancelAnimationFrame(raf);
    };
  }, [anima, testo]);

  if (!anima) return <span className={className}>{testo}</span>;
  return (
    <span ref={ref} className={className}>
      <span className="sr-only">{testo}</span>
      <span aria-hidden="true" className="tabular-nums">
        {n}
      </span>
    </span>
  );
};
